import tw, { styled } from 'twin.macro'

import { colors } from '../colors'

import {
   Text4xlLeading10FontSemibold,
   Text3xlLeading9FontSemibold,
   Text2xlLeading8FontSemibold,
   TextXlLeading7FontSemibold,
   TextXlLeading7FontMedium,
   TextLgLeading7FontMedium,
   TextBaseLeading6FontMedium,
   TextSmLeading5FontMedium,
   TextBaseLeading6FontNormal,
   TextSmLeading5FontNormal,
   TextXsLeading4FontNormal,
   TextXsLeading4FontMedium,
   TextLgLeading7Semibold,
   Text3xlLeading9FontBold,
   TextLgLeading7FontBold,
   TextSmLeading5FontSemiBold,
   TextXsLeading4FontSemiBold,
   TextBaseLeading6FontSemiBold,
   Text2xlLeading8FontBold,
   TextSmLeading5FontBold,
   TextBaseLeading6FontBold,
   TextXlLeading7FontBold,
   TextSmLeading5FontRegular,
   TextLgLeading7FontNormal,
   TextXsLeading7FontBold
} from './baseIndex'
import {
   TextFontLabel,
   ButtonFontAASmall,
   ButtonFontAALarge,
   ButtonFontAAMedium,
   TextFontL2Label,
   ButtonFontAATiny,
   BaseHKGroteskText,
   BaseHKGroteskBoldText,
   BaseHKGroteskSemiBoldText,
   TextFontS3Subtitle
} from './styledComponents'

export { ButtonFontAAMedium, TextFontS3Subtitle }

export const Text4xlLeading10FontSemiboldBlueGray600 = styled(
   Text4xlLeading10FontSemibold
)`
   color: ${colors['blue-gray-600']};
`
export const Text4xlLeading10FontSemiboldBlueGray200 = styled(
   Text4xlLeading10FontSemibold
)`
   color: ${colors['blue-gray-200']};
`
export const Text4xlLeading10FontSemiboldBlueGray900 = styled(
   Text4xlLeading10FontSemibold
)`
   color: ${colors['blue-gray-900']};
`

export const Text3xlLeading9FontSemiboldBlueGray900 = styled(
   Text3xlLeading9FontSemibold
)`
   color: ${colors['blue-gray-900']};
`

export const Text3xlLeading9FontSemiboldBlueGray800 = styled(
   Text3xlLeading9FontSemibold
)`
   color: ${colors['blue-gray-800']};
`
export const Text3xlLeading9FontBoldBlueGray700 = styled(
   Text3xlLeading9FontBold
)`
   color: ${colors['blue-gray-700']};
`

export const Text3xlLeading9FontBoldBlueGray800 = styled(
   Text3xlLeading9FontBold
)`
   color: ${colors['blue-gray-800']};
`

export const Text2xlLeading8FontBoldBlueGray700 = styled(
   Text2xlLeading8FontBold
)`
   color: ${colors['blue-gray-700']};
`
export const Text2xlLeading8FontBoldBlueGray800 = styled(
   Text2xlLeading8FontBold
)`
   color: ${colors['blue-gray-800']};
`
export const Text2xlLeading8FontSemiboldBlueGray200 = styled(
   Text2xlLeading8FontSemibold
)`
   color: ${colors['blue-gray-200']};
`
export const Text2xlLeading8FontSemiboldBlueGray700 = styled(
   Text2xlLeading8FontSemibold
)`
   color: ${colors['blue-gray-700']};
`
export const Text2xlLeading8FontSemiboldBlueGray800 = styled(
   Text2xlLeading8FontSemibold
)`
   color: ${colors['blue-gray-800']};
`
export const Text2xlLeading8FontSemiboldBlueGray900 = styled(
   Text2xlLeading8FontSemibold
)`
   color: ${colors['blue-gray-900']};
`
export const TextXlLeading7FontSemiboldBlueGray900 = styled(
   TextXlLeading7FontSemibold
)`
   color: ${colors['blue-gray-900']};
`

export const TextXlLeading7FontSemiboldBlueGray800 = styled(
   TextXlLeading7FontSemibold
)`
   color: ${colors['blue-gray-800']};
`
export const TextXlLeading7FontSemiboldBlueGray700 = styled(
   TextXlLeading7FontSemibold
)`
   color: ${colors['blue-gray-700']};
`

export const TextXlLeading7FontSemiboldBlueGray600 = styled(
   TextXlLeading7FontSemibold
)`
   color: ${colors['blue-gray-600']};
`
export const TextLgLeading7SemiboldBlueGray700 = styled(TextLgLeading7Semibold)`
   color: ${colors['blue-gray-700']};
`
export const TextLgLeading7SemiboldBlueGray800 = styled(TextLgLeading7Semibold)`
   color: ${colors['blue-gray-800']};
`
export const TextLgLeading7FontBoldBlueGray700 = styled(TextLgLeading7FontBold)`
   color: ${colors['blue-gray-700']};
`

export const TextLgLeading7FontBoldBlueGray800 = styled(TextLgLeading7FontBold)`
   color: ${colors['blue-gray-800']};
`
export const TextLgLeading7FontMediumBlueGray900 = styled(
   TextLgLeading7FontMedium
)`
   color: ${colors['blue-gray-900']};
`

export const TextLgLeading7FontMediumBlueGray800 = styled(
   TextLgLeading7FontMedium
)`
   color: ${colors['blue-gray-800']};
`

export const TextLgLeading7FontMediumBlueGray600 = styled(
   TextLgLeading7FontMedium
)`
   color: ${colors['blue-gray-600']};
`
export const TextLgLeading7FontMediumBlueGray700 = styled(
   TextLgLeading7FontMedium
)`
   color: ${colors['blue-gray-700']};
`

export const TextLgLeading7FontMediumBlueGray200 = styled(
   TextLgLeading7FontMedium
)`
   color: ${colors['blue-gray-200']};
`

export const TextLgLeading7FontMediumBlue500 = styled(TextLgLeading7FontMedium)`
   ${tw`text-blue-500`}
`

export const TextLgLeading7FontNormalBlueGray600 = styled(
   TextLgLeading7FontNormal
)`
   ${tw`text-blue-gray-600`}
`

export const TextBaseLeading6FontMediumBlueGray900 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-900']};
`
export const TextBaseLeading6FontMediumBlueGray700 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-700']};
`
export const TextBaseLeading6FontMediumBlueGray100 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-100']};
`
export const TextBaseLeading6FontMediumBlueGray500 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-500']};
`
export const TextBaseLeading6FontMediumBlueGray600 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-600']};
`
export const TextBaseLeading6FontMediumBlue500 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-500']};
`
export const TextBaseLeading6FontMediumCyan600 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['cyan-600']};
`
export const TextBaseLeading6FontMediumRed600 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['red-600']};
`
export const TextBaseLeading6FontMediumAmber600 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['amber-600']};
`
export const TextBaseLeading6FontMediumGreen500 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['green-500']};
`
export const TextSmLeading5FontMediumCyan600 = styled(TextSmLeading5FontMedium)`
   color: ${colors['cyan-600']};
`
export const TextBaseLeading6FontMediumBaseWhite = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['base-white']};
`
export const TextSmLeading5FontMediumBaseWhite = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['base-white']};
`

export const TextBaseLeading6FontMediumBlueGray800 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-800']};
`

export const TextFontS1SubtitleLightBlueGrey500 = styled(
   TextBaseLeading6FontMedium
)`
   color: ${colors['blue-gray-500']};
`

export const TextBaseLeading6FontSemiBoldBlueGray700 = styled(
   TextBaseLeading6FontSemiBold
)`
   color: ${colors['blue-gray-700']};
`
export const TextBaseLeading6FontSemiBoldBaseWhite = styled(
   TextBaseLeading6FontSemiBold
)`
   color: ${colors['base-white']};
`
export const TextSmLeading5FontMediumBlueGray900 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-900']};
`
export const TextSmLeading5FontMediumBlueGray800 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-800']};
`

export const TextFontLabelBasic600 = styled(TextFontLabel)`
   color: ${colors['blue-gray-600']};
`
export const TextFontL2LabelBasic600 = styled(TextFontL2Label)`
   color: ${colors['blue-gray-600']};
`
export const TextFontL2LabelBasic700 = styled(TextFontL2Label)`
   color: ${colors['blue-gray-700']};
`
export const TextXsLeading4FontMediumBlueGray900 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-900']};
`

export const TextXsLeading7FontBoldBlueGray700 = styled(TextXsLeading7FontBold)`
   color: ${colors['blue-gray-700']};
`

export const Text2xlLeading8FontSemiboldIndigo900 = styled(
   Text2xlLeading8FontSemibold
)`
   color: ${colors['indigo-900']};
`

export const TextSmLeading5FontMediumBlueGray700 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-700']};
`

export const TextSmLeading5FontMediumBlueGray600 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-600']};
`

export const TextSmLeading5FontMediumBlueGray500 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-500']};
`
export const TextSmLeading5FontMediumBlueGray400 = styled(
   TextSmLeading5FontMedium
)`
   color: ${colors['blue-gray-400']};
`

export const TextSmLeading5FontMediumBlue600 = styled(TextSmLeading5FontMedium)`
   color: ${colors['blue-600']};
`
export const TextSmLeading5FontMediumBlue700 = styled(TextSmLeading5FontMedium)`
   color: ${colors['blue-700']};
`

export const TextSmLeading5FontSemiBoldBlue600 = styled(
   TextSmLeading5FontSemiBold
)`
   color: ${colors['blue-600']};
`

export const TextXsLeading4FontMediumBlueGray500 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-500']};
`
export const TextXsLeading4FontMediumBlueGray400 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-400']};
`
export const TextXsLeading4FontMediumBlueGray700 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-700']};
`
export const TextFontC2CaptionBasic800 = styled(TextXsLeading4FontMedium)`
   color: ${colors['blue-gray-800']};
`

export const TextFontLabelBasic700 = styled(TextFontLabel)`
   color: ${colors['blue-gray-700']};
`

export const TextFontLabelBasic900 = styled(TextFontLabel)`
   color: ${colors['blue-gray-900']};
`

export const TextFontC2CaptionInfo600Default = styled(TextXsLeading4FontMedium)`
   color: ${colors['cyan-600']};
`
export const TextFontC2CaptionWarning600Default = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['amber-600']};
`
export const TextXsLeading4FontMediumBlueGray600 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-600']};
`
export const TextXsLeading4FontMediumBaseWhite = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['base-white']};
`

export const TextXsLeading4FontMediumRed600 = styled(TextXsLeading4FontMedium)`
   color: ${colors['red-600']};
`
export const TextXsLeading4FontMediumIndigo800 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['indigo-800']};
`

export const TextFontC1CaptionBasic600 = styled(TextXsLeading4FontNormal)`
   color: ${colors['blue-gray-600']};
`

export const TextXsLeading4FontNormalBlue9000 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-900']};
`
export const TextXsLeading4FontNormalBlue500 = styled(TextXsLeading4FontNormal)`
   color: ${colors['blue-500']};
`

export const TextXsLeading4FontNormalBlueGray500 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-500']};
`
export const TextXsLeading4FontNormalBlueGray900 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-900']};
`

export const TextXsLeading4FontNormalBlueGray200 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-200']};
`
export const TextXsLeading4FontNormalRed500 = styled(TextXsLeading4FontNormal)`
   color: ${colors['red-500']};
`
export const TextXsLeading4FontNormalBaseWhite = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['base-white']};
`

export const TextXsLeading4FontNormalBlueGray800 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-800']};
`

export const TextXsLeading4FontMediumBlue500 = styled(TextXsLeading4FontMedium)`
   color: ${colors['blue-500']};
`

export const TextXsLeading4FontMediumBlue800 = styled(TextXsLeading4FontMedium)`
   color: ${colors['blue-800']};
`
export const TextXsLeading4FontMediumBlue600 = styled(TextXsLeading4FontMedium)`
   color: ${colors['blue-600']};
`

export const TextXsLeading4FontMediumGreen500 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['green-500']};
`
export const TextXsLeading4FontMediumBlueGray200 = styled(
   TextXsLeading4FontMedium
)`
   color: ${colors['blue-gray-200']};
`

export const TextBaseLeading6FontNormalBlueGray700 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['blue-gray-700']};
`
export const TextBaseLeading6FontNormalBlueGray900 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['blue-gray-900']};
`
export const TextBaseLeading6FontNormalBlueGray600 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['blue-gray-600']};
`
export const TextBaseLeading6FontNormalBlue900 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['blue-900']};
`

export const TextBaseLeading6FontNormalBlueGray500 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['blue-gray-500']};
`

export const TextBaseLeading6FontNormalBaseWhite = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['base-white']};
`
export const TextBaseLeading6FontNormalCyan600 = styled(
   TextBaseLeading6FontNormal
)`
   color: ${colors['cyan-600']};
`

export const TextSmLeading5FontNormalBlue500 = styled(TextSmLeading5FontNormal)`
   color: ${colors['blue-500']};
`
export const TextSmLeading5FontNormalBlueGray900 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-900']};
`

export const TextSmLeading5FontNormalBlueGray600 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-600']};
`
export const TextSmLeading5FontNormalBlueGray800 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-800']};
`

export const TextSmLeading5FontNormalBlueGray700 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-700']};
`
export const TextSmLeading5FontNormalRed600 = styled(TextSmLeading5FontNormal)`
   color: ${colors['red-600']};
`
export const TextSmLeading5FontNormalBlueGray300 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-300']};
`

export const TextSmLeading5FontNormalBlueGray500 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-500']};
`
export const TextSmLeading5FontNormalBlueGray200 = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['blue-gray-200']};
`
export const TextSmLeading5FontNormalBaseWhite = styled(
   TextSmLeading5FontNormal
)`
   color: ${colors['base-white']};
`
export const ButtonFontAAMediumBasic600 = styled(ButtonFontAAMedium)`
   color: ${colors['blue-gray-600']};
`
export const ButtonFontAAMediumPrimary500Default = styled(ButtonFontAAMedium)`
   color: ${colors['blue-500']};
`
export const ButtonFontAATinyBasic600 = styled(ButtonFontAATiny)`
   color: ${colors['blue-gray-600']};
`
export const ButtonFontAALargeBasic1000 = styled(ButtonFontAALarge)`
   color: ${colors['blue-gray-900']};
`

export const ButtonFontAALargeBasic600 = styled(ButtonFontAALarge)`
   color: ${colors['blue-gray-600']};
`

export const ButtonFontAALargeWhite = styled(ButtonFontAALarge)`
   color: ${colors['base-white']};
`

export const ButtonFontAALargePrimary500Default = styled(ButtonFontAALarge)`
   ${tw`text-blue-500`}
`

export const ButtonFontAASmallPrimary500Default = styled(ButtonFontAASmall)`
   color: ${colors['blue-500']};
`

export const ButtonFontAASmallWhite = styled(ButtonFontAASmall)`
   color: ${colors['base-white']};
`

export const ButtonFontAASmallBasic500 = styled(ButtonFontAASmall)`
   color: ${colors['blue-gray-500']};
`

export const ButtonFontAASmallBasic600 = styled(ButtonFontAASmall)`
   color: ${colors['blue-gray-600']};
`

export const ButtonFontAAMediumTextColorDefault = styled(ButtonFontAAMedium)`
   color: ${colors['blue-gray-800']};
`

export const ButtonFontAAMediumWhite = styled(ButtonFontAAMedium)`
   color: ${colors['base-white']};
`
export const ButtonFontAATinyPrimary500Default = styled(ButtonFontAATiny)`
   color: ${colors['blue-500']};
`

export const TextFontS3SubtitleSteel = styled(TextFontS3Subtitle)`
   color: ${colors['blue-gray-500']};
`

//NOTE:These typos will be deprecated in future versions

export const BasePoppinsText = styled(BaseHKGroteskText)`
   font-family: 'Poppins';
`

export const Typo16BlackPoppins = styled(BasePoppinsText)`
   font-size: 16px;
   color: ${colors['base-black']};
`

export const Typo16BlackHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 16px;
   color: ${colors['base-black']};
`

export const Typo36BoldSolitudeHKGrotesk = styled(BaseHKGroteskBoldText)`
   font-size: 36px;
   color: ${colors['blue-gray-50']};
`
export const Typo12SemiBoldWhiteHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 12px;
   color: ${colors['blue-gray-50']};
`

export const Typo16SemiBoldBlackHKGrotesk = styled(BaseHKGroteskSemiBoldText)`
   font-size: 16px;
`

export const Typo16SemiBoldCloudBurstHKGrotesk = styled(
   BaseHKGroteskSemiBoldText
)`
   font-size: 16px;

   color: ${colors['blue-gray-700']};
`
export const Typo12BlackHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 12px;
   color: ${colors['base-black']};
`

export const Typo26BlackHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 26px;
`
export const Typo12LightSlateGreyHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 12px;
   color: ${colors['blue-gray-400']};
`
export const Typo12GreyHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 12px;
   color: ${colors['blue-gray-300']};
`

export const Typo12PinkishOrangeHKGrotesk = styled(BaseHKGroteskText)`
   font-size: 12px;
   color: ${colors['orange-600']};
`
export const Typo12SemiBoldMischkaHKGrotesk = styled(BaseHKGroteskSemiBoldText)`
   font-size: 12px;
   color: ${colors['blue-gray-500']};
`

export const Typo12SemiBoldFireEngineRedHKGrotesk = styled(
   BaseHKGroteskSemiBoldText
)`
   font-size: 12px;
   color: ${colors['red-600']};
`

export const LinkText = styled(TextSmLeading5FontNormalBlue500)`
   ${tw`cursor-pointer`}
`

export const TextXsLeading4FontSemiBoldBlueGray400 = styled(
   TextXsLeading4FontSemiBold
)`
   ${tw`text-blue-gray-400`}
`
export const TextXsLeading4FontSemiBoldBlueGray500 = styled(
   TextXsLeading4FontSemiBold
)`
   ${tw`text-blue-gray-500`}
`

export const TextXsLeading4FontSemiBoldBlueGray700 = styled(
   TextXsLeading4FontSemiBold
)`
   ${tw`text-blue-gray-700`}
`

export const TextXlLeading7FontMediumBlueGray700 = styled(
   TextXlLeading7FontMedium
)`
   color: ${colors['blue-gray-700']};
`

export const TextXlLeading7FontMediumBlueGray800 = styled(
   TextXlLeading7FontMedium
)`
   color: ${colors['blue-gray-800']};
`

export const TextSmLeading5FontSemiBoldBlueGray800 = styled(
   TextSmLeading5FontSemiBold
)`
   color: ${colors['blue-gray-800']};
`
export const TextSmLeading5FontSemiBoldBlueGray600 = styled(
   TextSmLeading5FontSemiBold
)`
   color: ${colors['blue-gray-600']};
`
export const TextSmLeading5FontSemiBoldBaseWhite = styled(
   TextSmLeading5FontSemiBold
)`
   color: ${colors['base-white']};
`
export const TextXsLeading4FontNormalBlueGray600 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-600']};
`

export const TextXsLeading4FontNormalBlueGray700 = styled(
   TextXsLeading4FontNormal
)`
   color: ${colors['blue-gray-700']};
`

export const TextSmLeading5FontBoldBlueGray700 = styled(TextSmLeading5FontBold)`
   color: ${colors['blue-gray-700']};
`

export const TextSmLeading5FontBoldBlueGray600 = styled(TextSmLeading5FontBold)`
   color: ${colors['blue-gray-600']};
`

export const TextSmLeading5FontBoldBaseWhite = styled(TextSmLeading5FontBold)`
   color: ${colors['base-white']};
`

export const TextSmLeading5FontSemiBoldBlueGray700 = styled(
   TextSmLeading5FontSemiBold
)`
   color: ${colors['blue-gray-700']};
`

export const TextBaseLeading6FontBoldBlueGray700 = styled(
   TextBaseLeading6FontBold
)`
   color: ${colors['blue-gray-700']};
`

export const TextXlLeading7FontBoldBlueGray700 = styled(TextXlLeading7FontBold)`
   color: ${colors['blue-gray-700']};
`
export const TextXlLeading7FontBoldBlueGray800 = styled(TextXlLeading7FontBold)`
   color: ${colors['blue-gray-800']};
`
export const TextXlLeading7FontBoldBlueGray50 = styled(TextXlLeading7FontBold)`
   color: ${colors['blue-gray-50']};
`
export const TextSmLeading5FontRegularBlueGray700 = styled(
   TextSmLeading5FontRegular
)`
   color: ${colors['blue-gray-700']};
`
export const TextSmLeading5FontRegularBlue600 = styled(
   TextSmLeading5FontRegular
)`
   color: ${colors['blue-600']};
`
export const TextSmLeading5FontRegularBlueGray600 = styled(
   TextSmLeading5FontRegular
)`
   color: ${colors['blue-gray-600']};
`
export const TextSmLeading5FontNormalBlue600 = styled(TextSmLeading5FontNormal)`
   color: ${colors['blue-600']};
`
